module.exports = __webpack_public_path__ + "static/img/battleReportBg1.de2bb6ab.png";